<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <v-spacer></v-spacer>
      <!-- <v-row v-if="showSearch" align="center" style="max-width: 300px;">
        <v-text-field
          flat
          hide-details
          solo
          rounded
          clearable
          background-color="grey lighten-3"
          label="Search"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row> -->

      <!--       <v-skeleton-loader
        type="actions"
        transition="fade-transition"
        v-if="loading"
      ></v-skeleton-loader>

      <template v-else>
        <v-btn class="ml-5" icon @click="showSearch = !showSearch">
          <img src="@/assets/icons/search.svg" alt height="17.7px" />
        </v-btn>
      </template> -->

      <v-select
        style="max-width: 200px;"
        v-model="filter.status"
        :items="status"
        item-text="label"
        item-value="value"
        menu-props="auto"
        hide-details
        label="Filter status"
        single-line
        @change="search"
      ></v-select>
    </v-app-bar>

    <div
      class="mx-4"
      id="transaction-list"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="100"
    >
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Tool</th>
            <th class="text-left">Owner</th>
            <th class="text-left">Renter</th>
            <th class="text-left">Date</th>
            <th class="text-left">Request date</th>
            <th class="text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="transaction in transactions"
            :key="transaction.id"
            class="clickable"
            @click="
              $router.push({
                name: 'user.transaction.details',
                params: { id: userUid, transactionId: transaction.renter_code }
              })
            "
          >
            <td class="py-5">
              {{ transaction.toolName }}
            </td>
            <td class="py-5">{{ transaction.ownerName }}</td>
            <td class="py-5">{{ transaction.renterName }}</td>
            <td class="py-5">{{ transaction.rentDate }}</td>
            <td class="py-5">{{ transaction.addedDate }}</td>
            <td class="py-5">
              <v-btn x-small outlined :color="transaction.statusColor" dark>
                {{ transaction.status }}
              </v-btn>
            </td>
          </tr>

          <template v-if="loading">
            <tr v-for="index in 10" :key="index + '-skeleton'">
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { mdiMagnify } from '@mdi/js'
import infiniteScroll from 'vue-infinite-scroll'
import debounce from 'lodash/debounce'
import User from '@/models/User'

export default {
  name: 'UsersTransactionPage',

  directives: {
    infiniteScroll
  },

  props: {
    user: {
      type: [User, Object]
    }
  },

  data() {
    return {
      loading: false,
      showSearch: false,
      filter: {
        search: '',
        status: null
      },
      icons: {
        search: mdiMagnify
      },
      status: [
        { label: 'All', value: null },
        { label: 'Pending', value: 'pending' },
        { label: 'Accepted', value: 'accepted' },
        { label: 'Declined', value: 'declined' },
        { label: 'Expired', value: 'expired' }
      ]
    }
  },

  created() {
    this.clearTransactions()
    this.fetchTransactions(1)
  },

  computed: {
    ...mapState({
      transactions: state => state.transaction.list,
      listMeta: state => state.transaction.listMeta
    }),

    userUid() {
      return this.user ? this.user.id : null
    },

    paginationLength() {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    }
  },

  methods: {
    ...mapActions({
      getTransactions: 'transaction/getTransactions'
    }),

    ...mapMutations({
      clearTransactions: 'transaction/clearTransactionList'
    }),

    pageChanged(page) {
      this.fetchTransactions(page)
    },

    loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchTransactions(this.listMeta.current_page + 1)
      }
    },

    search: debounce(function() {
      this.clearTransactions()
      this.fetchTransactions()
    }, 600),

    async fetchTransactions(page = 1) {
      if (this.loading) return
      let params = { page }
      if (this.user) {
        params.user = this.user.id
      }
      if (this.filter.search) {
        params.search = this.filter.search
      }
      if (this.filter.status) {
        params.status = this.filter.status
      }

      this.loading = true
      await this.getTransactions(params)
      this.loading = false
    }
  }
}
</script>
